import { SHORTS_HOME_PATH } from './buildShortsLocationPath';

/** Navega para /shorts/home removendo a localização do path. Store deve limpar os arrays antes. */
export function stripShortsLocationPathFromRoute(): void {
	if (import.meta.server) return;
	void navigateTo({ path: SHORTS_HOME_PATH }, { replace: true });
}

/** @deprecated Use stripShortsLocationPathFromRoute */
export const stripShortsLocationQueryFromRoute =
	stripShortsLocationPathFromRoute;
